import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/apps/cue-subclient/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/app/apps/cue-subclient/app/layouts/error.vue").then(m => m.default || m))
}